angular.module('eStories.home', [
    'eStories.compnt.carousel',
    'eStories.catalog.model'
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.home', {
                url: '^eStories.navbars',
                views: {
                    'mainView@': {
                        templateUrl: 'home/home.tmpl.html',
                        controller: 'HomeCtrl as homeCtrl'
                    }
                }
            })
            .state('eStories.navbars.startTrial', {
                url: 'startTrial',
                views: {
                    'mainView@': {
                        templateUrl: 'home/home.tmpl.html',
                        controller: 'HomeCtrl as homeCtrl'
                    }
                }
            })
            .state('eStories.navbars.homepage', {
                url: 'home',
                views: {
                    'mainView@': {
                        templateUrl: 'home/home.tmpl.html',
                        controller: 'HomeCtrl as homeCtrl'
                    }
                }
            })

            .state('eStories.navbars.vipSignUp', {
                url: '2cdt',
                views: {
                    'mainView@': {
                        templateUrl: 'home/newUserHome.tmpl.html',
                        controller: 'HomeCtrl as homeCtrl'
                    }
                }
            })

            .state('eStories.navbars.newUser', {
                url: 'newuser',
                views: {
                    'mainView@': {
                        templateUrl: 'home/newUserHome.tmpl.html',
                        controller: 'HomeCtrl as homeCtrl'
                    }
                }
            })

            .state('eStories.navbars.signIn', {
                url: 'signin',
                views: {
                    'mainView@': {
                        templateUrl: 'home/home.tmpl.html',
                        controller: 'HomeCtrl as homeCtrl'
                    }
                }
            })
            .state('eStories.navbars.signUp', {
                url: 'signup',
                views: {
                    'mainView@': {
                        templateUrl: 'home/home.tmpl.html',
                        controller: 'HomeCtrl as homeCtrl'
                    }
                }
            })
            .state('eStories.navbars.dailydeal', {
                url: 'dailydeal',
                views: {
                    'mainView@': {
                        templateUrl: 'home/home.tmpl.html',
                        controller: 'HomeCtrl as homeCtrl'
                    }
                }
            })
    }])

    .controller('HomeCtrl', [
        'CatalogModel',
        'BillingModel',
        '$rootScope',
        '$state',
        '$location',
        'PagingModel',
        '$scope',
        'ModalsModel',
        '$timeout',
        '$stateParams',
        'SeoModel',
        '$filter',
        'AccountModel',
        '$aria',
        'GA',
        function (CatalogModel, BillingModel, $rootScope, $state, $location, PagingModel, $scope, ModalsModel, $timeout,
                  $stateParams, SeoModel, $filter, AccountModel, $aria, GA) {

            GA.trackPageView($location.path());

            SeoModel.applyMetaTags($state.current.name);

            PagingModel.resetPagingData();

            this.dailyDealShow = expiration => {
                if (expiration) {
                    let future;
                    future = new Date(expiration);
                    let diff;
                    let now = new Date().getTime();
                    diff = Math.floor((future.getTime() - now) / 1000);
                    if (diff > 0) {
                        return true;
                    } else {
                        return true;
                    }
                }
            };

            this.getGridCarouselData = sectionId => this.landingSectionItemListMap[sectionId];

            this.updatePurchasedItem = function (sectionList, sectionType, index, purchaseDate) {
                for (let i = 0; i < sectionList.length; i++) {
                    if (sectionList[i].sectionType === sectionType) {
                        sectionList[i].sectionItemList[index].audiobook.purchaseDate = purchaseDate;
                    }
                }
            };

            this.getAllSections = async () => {
                const response = await CatalogModel.getSectionList(null);
                const sectionList = response.sectionList;
                // Map between context to list of sections
                this.landingSectionsMap = {};

                // Map between section id to sectionItem list
                this.landingSectionItemListMap = {};
                let halfEndCapArray = [];
                sectionList.forEach(section => {

                    let sectionContext = section.sectionContext;
                    //console.log(section.id + "   " + section.sectionType + "  " + section.sectionContext);
                    if (this.landingSectionsMap[sectionContext] == null) {
                        this.landingSectionsMap[sectionContext] = [];
                    }

                    if (section.sectionType === 'HALF_END_CAP' || section.sectionType === 'END_CAP_LINK') {
                        halfEndCapArray.push(section);

                    } else {
                        // looking for a groupon promotional 2 credit 2 month trial landing feature carousel slide here -
                        // don't include it if not right trial type

                        // looking for CYBER50 landing feature carousel slide here -
                        // don't include it if user has a subscription already

                        if (sectionContext === "LANDING_FEATURE_CAROUSEL") {
                            if (section.name === 'THEMED_GROUPON_2MO2CDT' && AccountModel.trialTypeSponsor !== 'groupon') {
                                return;
                            }
                            if (section.name === 'THEMED_GROUPON_2MO2CDT' && AccountModel.trialType !== 'twoMo2cdt') {
                                return;
                            } else if (section.name === 'PROMO_BANNER_CYBER50' && AccountModel.subscriptionDetails !== null) {
                                section.showOnlyForNonMembers = true;
                                return;
                            } else {
                                this.landingSectionsMap[sectionContext].push(section);
                            }
                        } else {
                            section.isFirst = this.landingSectionsMap[sectionContext].length === 0;
                            this.landingSectionsMap[sectionContext].push(section);
                        }
                    }

                    if (section.sectionItemList && section.sectionItemList.length) {
                        this.landingSectionItemListMap[section.id] = section.sectionItemList;
                    } else if (sectionContext === 'LANDING_SECTIONS' &&
                        ['GRID', 'END_CAP_DEAL'].indexOf(section.sectionType) !== -1) {

                        let pageSize;
                        switch (section.sectionType) {
                            case 'GRID':
                                pageSize = 36;
                                break;
                            case 'END_CAP_DEAL':
                                pageSize = 12;
                                break;
                        }

                        let getSectionItemListObj = {
                            sectionId: section.id,
                            pagination: PagingModel.preparePagination(
                                1,
                                pageSize,
                                this.getDefaultDescending(section.id),
                                null,
                                this.getDefaultSortField(section.id))
                        };

                        CatalogModel.getSectionItemList(getSectionItemListObj).then(r => {
                            if (r.sectionItemList) {
                                this.landingSectionItemListMap[section.id] = r.sectionItemList;
                                safeApply($scope);
                            }
                        });

                    }
                });

                const fullCapSection = this.appendHalfCapSections(halfEndCapArray);
                if (fullCapSection) {
                    this.landingSectionsMap['LANDING_SECTIONS'].push(fullCapSection);
                }

                CatalogModel.landingSectionsMap = this.landingSectionsMap;
                CatalogModel.landingSectionItemListMap = this.landingSectionItemListMap;
                safeApply($scope);

            };

            this.appendHalfCapSections = (halfEndCapArray) => {
                if (!halfEndCapArray.length) {
                    return null;
                }

                const fullCap = {sectionType: "HALF_END_CAP", subSections: []};

                for (let i = 0; i < halfEndCapArray.length; i++) {
                    const section = halfEndCapArray[i];
                    if (fullCap.subSections.length === 2) {
                        return fullCap;
                    }

                    if (section.sectionType === 'END_CAP_LINK') {
                        const isValidBookPromoLink = AccountModel.isUserLoggedIn &&
                            section.name === "BOOK_UPLOAD_PROMO_END_CAP_LINK";
                        const isAppPromoLink = section.name === "APP_PROMO_END_CAP_LINK";
                        if (!isValidBookPromoLink && !isAppPromoLink) {
                            continue;
                        }
                    }

                    fullCap.subSections.push(section);
                }

                return fullCap;
            };

            this.getDefaultSortField = function (sectionId) {
                switch (true) {
                    case (sectionId.indexOf('GREAT_FIRST') > -1):
                    case (sectionId.indexOf('GREAT_SUMMER') > -1):
                    case (sectionId.indexOf('NEW_RELEASES') > -1):
                        return null;
                    default:
                        return 'MOST_POPULAR_THIS_WEEK';
                }
            };

            this.playSample = audiobook => {
                $rootScope.$broadcast('playSample', audiobook);
            };

            this.getDefaultDescending = function (sectionId) {
                if (sectionId.indexOf('BEST_SELLERS') > -1 || sectionId.indexOf('EDITORS_PICKS') > -1) {
                    return true;
                }
                return null;
            };

            $rootScope.$on('refreshHomePageSections', () => {
                this.getAllSections();
            });

            //check if landing sections map is cached

            if (CatalogModel.landingSectionsMap) {
                this.landingSectionsMap = CatalogModel.landingSectionsMap;
                this.landingSectionItemListMap = CatalogModel.landingSectionItemListMap;
            } else if (!CatalogModel.loadHomePageSectionsAsync) {
                this.getAllSections();
            }

            /*Setting Vip 2 Credit SignUp , this variable is used to toggle Modal Header and Subscription Request on updatePaymentDetails.js*/
            if ($rootScope.currentState === 'eStories.navbars.vipSignUp') {
                AccountModel.trialType = 'vipSignUp';
            }

            /* RESET PASSWORD */
            if ($rootScope.currentState === 'eStories.navbars.resetPw') {
                $rootScope.resetPwToken = $stateParams.resetPwToken;
                //Wait and open reset Password Modal
                ModalsModel.open('/registration/resetPassword/resetPw.tmpl.html', 'RegistrationCtrl', 'regCtrl');
            }

            if ($rootScope.currentState === 'eStories.navbars.signIn') {
                ModalsModel.open('/registration/signInModal.tmpl.html', 'RegistrationCtrl', 'regCtrl');
            }

            if ($rootScope.currentState === 'eStories.navbars.signUp') {
                ModalsModel.open('/registration/signUpModal.tmpl.html', 'RegistrationCtrl', 'regCtrl');
            }

            if ($rootScope.currentState === 'eStories.navbars.homepage') {
                $state.go('eStories.navbars.home')
            }

            if ($location.path() === "/startTrial") {
                AccountModel.setPendingPlanPurchaseType("BASIC_TRIAL");
                if (AccountModel.userDetails == null) {
                    AccountModel.showSignUp();
                } else {
                    AccountModel.showUpdatePaymentDetailsModal();
                }
            }

            if ($location.path() === "/dailydeal") {
                document.location.href = '/eStories/rest/catalog/dailyDeal';
            }


            $rootScope.$broadcast('homeCtrlLoaded');

        }]);
